export default "__VITE_ASSET__Cr11KhCx__"